import { Badge, type BadgeTone } from './Badge';

const STATUS_TONE: Record<string, BadgeTone> = {
  Connected: 'ok',
  Live: 'ok',
  Success: 'ok',
  Active: 'ok',
  Warning: 'warn',
  Pending: 'warn',
  Draft: 'info',
  Available: 'info',
  Disconnected: 'err',
  Missing: 'err',
  Failed: 'err',
  Paused: 'default',
};

interface Props {
  status: string;
}

export function StatusBadge({ status }: Props) {
  const tone = STATUS_TONE[status] ?? 'default';
  return <Badge tone={tone}>{status}</Badge>;
}
